import {
  AbpApplicationConfigurationService,
  ApplicationConfigurationDto,
  ApplicationConfigurationRequestOptions,
} from '@abp/ng.core';
import { inject, Injectable } from '@angular/core';
import { Observable, from, map, switchMap, tap } from 'rxjs';
import { LocalStorageConsts } from '../AppConsts';
import { AppUtils } from '../utils/app-utils';
import { LocalConfigurationType } from '../entities/local-configuration';
import { LocalConfigurationRepository } from '../local-db/repositries/local-configuration-repository';
import { HealthCheckService } from 'src/app/proxy/health-checks';

@Injectable({
  providedIn: 'root',
})
export class CustomApplicationConfigurationService {
  private readonly _abpApplicationConfigurationService: AbpApplicationConfigurationService;
  private readonly _localConfigurationRepository: LocalConfigurationRepository;
  private readonly serviceProxy: HealthCheckService;

  constructor() {
    this._abpApplicationConfigurationService = new AbpApplicationConfigurationService();

    this._localConfigurationRepository = inject(LocalConfigurationRepository)
    this.serviceProxy = inject(HealthCheckService);
  }

  get: (options: ApplicationConfigurationRequestOptions) => Observable<ApplicationConfigurationDto> = options => {
    const instance = this as CustomApplicationConfigurationService;
    const userFromLocalStorage = localStorage.getItem(LocalStorageConsts.CurrentUserKey);
    const user = userFromLocalStorage ? JSON.parse(userFromLocalStorage) : undefined;

    return instance.serviceProxy.checkHealth().pipe(
      switchMap(isOnline => {
        if (isOnline) {
          return instance._abpApplicationConfigurationService.get(options).pipe(
            tap(response => {
              instance._localConfigurationRepository.set(
                response?.currentUser?.id ?? '',
                LocalConfigurationType.ApplicationConfiguration,
                response,
              );

              if (AppUtils.emptyString(response?.currentUser?.id)) {
                localStorage.removeItem(LocalStorageConsts.CurrentUserKey);
              } else {
                localStorage.setItem(LocalStorageConsts.CurrentUserKey, JSON.stringify(response.currentUser));
              }
            }),
          );
        } else {
          return from(
            instance._localConfigurationRepository.get(user?.id ?? '', LocalConfigurationType.ApplicationConfiguration),
          ).pipe(map(resp => resp.data as ApplicationConfigurationDto));
        }
      })
    );
  };
}
